export default __webpack_public_path__ + "static/media/gif.e91b23ba.svg";